import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import ar from '../assets/translations/ar.json';
import en from '../assets/translations/en.json';

const resources = {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en-US',

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
